// Lightweight i18n for Oak AI Campus UI strings.
// Full-site translation across 8 primary languages; others fall back to English.
// AI-generated content respects the full 25-language list through the backend.

export const TRANSLATIONS = {
  en: {
    nav_home: "Home", nav_academy: "Academy", nav_planner: "Planner", nav_library: "Library", nav_profile: "Profile",
    nav_earn_credits: "Earn Credits",
    header_brand_tagline: "Master anything · Oak AI Campus",
    header_watch_ad: "Watch ad · +1",
    header_get_credits: "Get credits",
    header_upgrade: "Upgrade Now",
    header_credits: "credit",
    hub_eyebrow: "Universal Learning Hub",
    hub_title_pre: "What do you want to",
    hub_title_word: "master",
    hub_title_post: "today?",
    hub_sub: "Type anything — in your language, in your voice. Oak AI Campus builds a 30-minute, 5-step mastery path. Save, simulate, certify.",
    hub_placeholder: "Learn derivatives, quantum mechanics, macro-economics…",
    btn_generate: "Generate",
    pillar_academy: "AI Academy", pillar_academy_body: "5-step paths, 30-min whitepapers, adaptive exams.",
    pillar_planner: "Planner", pillar_planner_body: "Auto-populate schedules & reminders.",
    pillar_library: "My Library", pillar_library_body: "Saved whitepapers, in-app PDFs.",
    pillar_referrals: "Referrals", pillar_referrals_body: "Invite & unlock premium voices.",
    pillar_certs: "Certificates", pillar_certs_body: "Earn, share on LinkedIn & more.",
    modes_title: "Learning Modes",
    mode_universal: "Universal Language",
    mode_universal_body: "Native generation in 25 languages including Hindi, Mandarin, Japanese, German, French, Arabic.",
    mode_sim: "Simulation Mode",
    mode_sim_body: "Interactive roleplay: face a decision, pick options, get debriefed.",
    mode_cross: "Cross-Pollination",
    mode_cross_body: "Pick any lens — sports, art, biology — and see the topic through it.",
    modes_tooltip: "Explore these features by clicking on the AI Academy section.",
    cert_eyebrow: "Unlocked Certificate",
    cert_title: "Your Oak AI Campus certificate",
    cert_sub: "A cinematic, brand-owned credential. Capture it as an image and share across platforms.",
    cert_label_name: "This certifies that",
    cert_completed: "has completed a structured mastery path on",
    cert_equity: "Knowledge Equity",
    cert_modules: "Modules",
    cert_exams: "Exams",
    cert_saved: "Saved PDFs",
    cert_issued: "Issued",
    cert_founder: "Issued by Oak AI Campus",
    cert_back: "Back",
    cert_image_btn: "Cinematic image",
    cert_image_rendering: "Rendering…",
    cert_json: "JSON record",
    open: "Open",
    // Course discovery (cascading dropdowns + recommendations)
    discover_eyebrow: "Find your course",
    discover_title: "Confused what you want to learn today? Let us help.",
    discover_sub: "Pick a category and a focus area — we'll surface the most popular and high-impact courses for you. One click generates the full path.",
    discover_pick_category: "1. Pick a category",
    discover_pick_category_placeholder: "Choose a category…",
    discover_pick_subcategory: "2. Pick a focus area",
    discover_pick_subcategory_placeholder: "Choose a focus area…",
    discover_pick_subcategory_disabled: "Pick a category first",
    discover_hot_trending: "Hot · Trending across the platform",
    discover_hot_in_category: "Hot in {cat}",
    discover_hot_in_subcategory: "Hot in {sub}",
    discover_chip_hint: "Click to generate this course",
    // Header / hamburger
    nav_my_courses: "My Courses",
    my_courses_empty: "No courses yet — generate one from the dashboard.",
    loading: "Loading…",
    // Free badge on Course Discovery
    discover_free_credits: "Free with your credits",
    discover_free_limitless: "Free · Limitless plan",
    discover_free_hint: "Each course = 1 credit (or unlimited on Limitless)",
    // Footer
    footer_tagline: "Master anything. Powered by Oak AI Campus.",
    footer_blurb: "A cinematic, AI-guided path to mastery. Built for relentless learners.",
    footer_legal: "Legal",
    footer_privacy: "Privacy Policy",
    footer_terms: "Terms of Service",
    footer_refund: "Refund Policy",
    footer_settings: "Settings & Privacy",
    footer_contact: "Contact",
    footer_concept: "Conceptualized by",
    footer_built_by: "and built by",
    footer_rights: "All rights reserved",
    // Live Preview Showcase
    showcase_eyebrow: "Live previews · one per category",
    showcase_paths_count: "{n} paths",
    showcase_added_this_week: "{n} added this week",
    showcase_title: "Peek into a real OAK course",
    showcase_subtitle: "Free 10% preview on every path · unlock the rest with 6 free credits on signup.",
    showcase_explore_more: "Explore more live previews",
    showcase_empty: "No public previews yet — check back soon.",
    showcase_free_pct: "10% free",
    showcase_read_preview: "Read preview",
    // Language & tone help text
    lang_persona_help: "Language & tone control the AUDIO and COURSE content (whitepapers, exam questions, narration). Website chrome translates to your language too where supported.",
  },
  hi: {
    nav_home: "होम", nav_academy: "अकादमी", nav_planner: "प्लानर", nav_library: "लाइब्रेरी", nav_profile: "प्रोफ़ाइल",
    header_brand_tagline: "सब कुछ सीखें · Oak AI Campus",
    header_watch_ad: "विज्ञापन देखें · +1",
    header_get_credits: "क्रेडिट लें",
    header_upgrade: "अभी अपग्रेड करें",
    header_credits: "क्रेडिट",
    hub_eyebrow: "यूनिवर्सल लर्निंग हब",
    hub_title_pre: "आज आप क्या",
    hub_title_word: "सीखना",
    hub_title_post: "चाहते हैं?",
    hub_sub: "कुछ भी टाइप करें — अपनी भाषा में, अपने अंदाज़ में। Oak AI Campus 30-मिनट का 5-चरणीय मास्टरी पथ बनाता है।",
    hub_placeholder: "डेरिवेटिव्स, क्वांटम मैकेनिक्स, मैक्रो-इकॉनमिक्स सीखें…",
    btn_generate: "उत्पन्न करें",
    pillar_academy: "एआई अकादमी", pillar_academy_body: "5-चरणीय पथ, 30-मिनट व्हाइटपेपर, एडैप्टिव परीक्षा।",
    pillar_planner: "प्लानर", pillar_planner_body: "स्वचालित शेड्यूल और रिमाइंडर।",
    pillar_library: "मेरी लाइब्रेरी", pillar_library_body: "सहेजे गए व्हाइटपेपर, इन-ऐप PDF।",
    pillar_referrals: "रेफरल", pillar_referrals_body: "आमंत्रित करें और प्रीमियम अनलॉक करें।",
    pillar_certs: "प्रमाण-पत्र", pillar_certs_body: "कमाएँ, LinkedIn पर साझा करें।",
    modes_title: "सीखने के तरीके",
    mode_universal: "यूनिवर्सल भाषा",
    mode_universal_body: "हिंदी, मैंडरिन, जापानी, जर्मन सहित 25 भाषाओं में मूल पीढ़ी।",
    mode_sim: "सिमुलेशन मोड",
    mode_sim_body: "इंटरएक्टिव रोलप्ले: निर्णय चुनें, सीखें।",
    mode_cross: "क्रॉस-पॉलिनेशन",
    mode_cross_body: "कोई भी लेंस चुनें — खेल, कला, जीवविज्ञान।",
    open: "खोलें",
    nav_earn_credits: "क्रेडिट अर्जित करें",
    modes_tooltip: "AI Academy सेक्शन पर क्लिक करके इन सुविधाओं को एक्सप्लोर करें।",
    cert_eyebrow: "प्रमाणपत्र अनलॉक किया गया",
    cert_title: "आपका Oak AI Campus प्रमाणपत्र",
    cert_sub: "एक सिनेमाई, ब्रांड-स्वामित्व वाली प्रमाण-पत्र। इसे एक छवि के रूप में कैप्चर करें और विभिन्न प्लेटफार्मों पर साझा करें।",
    cert_label_name: "यह प्रमाणित करता है कि",
    cert_completed: "ने पर एक संरचित महारत पथ पूरा कर लिया है",
    cert_equity: "ज्ञान समता",
    cert_modules: "मॉड्यूल",
    cert_exams: "परीक्षाएँ",
    cert_saved: "सहेजे गए PDF",
    cert_issued: "जारी किया गया",
    cert_founder: "Oak AI Campus द्वारा जारी",
    cert_back: "वापस",
    cert_image_btn: "सिनेमाई छवि",
    cert_image_rendering: "रेंडरिंग हो रही है…",
    cert_json: "JSON रिकॉर्ड",
    discover_eyebrow: "अपना कोर्स ढूँढें",
    discover_title: "भ्रमित हैं कि आप आज क्या सीखना चाहते हैं? हम मदद करेंगे।",
    discover_sub: "एक श्रेणी और एक केंद्रित क्षेत्र चुनें — हम आपके लिए सबसे लोकप्रिय और उच्च-प्रभाव वाले कोर्स सामने लाएंगे। एक क्लिक से पूरा पथ जनरेट हो जाता है।",
    discover_pick_category: "1. एक श्रेणी चुनें",
    discover_pick_category_placeholder: "एक श्रेणी चुनें…",
    discover_pick_subcategory: "2. एक केंद्रित क्षेत्र चुनें",
    discover_pick_subcategory_placeholder: "एक केंद्रित क्षेत्र चुनें…",
    discover_pick_subcategory_disabled: "पहले एक श्रेणी चुनें",
    discover_hot_trending: "हॉट · पूरे प्लेटफ़ॉर्म पर ट्रेंडिंग",
    discover_hot_in_category: "{cat} में हॉट",
    discover_hot_in_subcategory: "{sub} में हॉट",
    discover_chip_hint: "इस कोर्स को जनरेट करने के लिए क्लिक करें",
    discover_free_credits: "आपके क्रेडिट के साथ मुफ़्त",
    discover_free_limitless: "मुफ़्त · लिमिटलेस प्लान",
    discover_free_hint: "प्रत्येक कोर्स = 1 क्रेडिट (या लिमिटलेस पर असीमित)",
    footer_tagline: "कुछ भी महारत हासिल करें। Oak AI Campus द्वारा संचालित।",
    footer_blurb: "महारत के लिए एक सिनेमाई, AI-निर्देशित पथ। अथक सीखने वालों के लिए निर्मित।",
    footer_legal: "कानूनी",
    footer_privacy: "गोपनीयता नीति",
    footer_terms: "सेवा की शर्तें",
    footer_refund: "वापसी नीति",
    footer_settings: "सेटिंग्स और गोपनीयता",
    footer_contact: "संपर्क करें",
    footer_concept: "द्वारा परिकल्पित",
    footer_built_by: "और द्वारा निर्मित",
    footer_rights: "सभी अधिकार सुरक्षित",
    showcase_eyebrow: "लाइव प्रीव्यू · प्रति श्रेणी एक",
    showcase_paths_count: "{n} पथ",
    showcase_added_this_week: "इस सप्ताह {n} जोड़े गए",
    showcase_title: "एक वास्तविक OAK कोर्स में झाँकें",
    showcase_subtitle: "हर पथ पर 10% मुफ़्त प्रीव्यू · साइनअप पर 6 मुफ़्त क्रेडिट के साथ बाकी अनलॉक करें।",
    showcase_explore_more: "और अधिक लाइव प्रीव्यू एक्सप्लोर करें",
    showcase_empty: "अभी तक कोई सार्वजनिक प्रीव्यू नहीं हैं — जल्द ही वापस देखें।",
    showcase_free_pct: "10% मुफ़्त",
    showcase_read_preview: "प्रीव्यू पढ़ें",
    lang_persona_help: "भाषा और टोन ऑडियो और कोर्स सामग्री (श्वेतपत्र, परीक्षा प्रश्न, वर्णन) को नियंत्रित करती हैं। वेबसाइट क्रोम भी आपकी भाषा में अनुवादित होता है जहाँ समर्थित हो।",
    nav_my_courses: "मेरे पाठ्यक्रम",
    my_courses_empty: "अभी तक कोई पाठ्यक्रम नहीं — डैशबोर्ड से एक बनाएं।",
    loading: "लोड हो रहा है…",
      },
  de: {
    nav_home: "Start", nav_academy: "Akademie", nav_planner: "Planer", nav_library: "Bibliothek", nav_profile: "Profil",
    header_brand_tagline: "Alles meistern · Oak AI Campus",
    header_watch_ad: "Werbung ansehen · +1",
    header_get_credits: "Credits holen",
    header_upgrade: "Jetzt upgraden",
    header_credits: "Credit",
    hub_eyebrow: "Universaler Lern-Hub",
    hub_title_pre: "Was möchtest du heute",
    hub_title_word: "meistern",
    hub_title_post: "?",
    hub_sub: "Tippe irgendetwas — in deiner Sprache, in deinem Ton. Oak AI Campus baut einen 30-Minuten-Meisterpfad in 5 Schritten.",
    hub_placeholder: "Derivate, Quantenmechanik, Makroökonomie…",
    btn_generate: "Erzeugen",
    pillar_academy: "KI-Akademie", pillar_academy_body: "5-Schritte-Pfade, 30-Min-Whitepaper, adaptive Prüfungen.",
    pillar_planner: "Planer", pillar_planner_body: "Zeitpläne & Erinnerungen automatisch.",
    pillar_library: "Meine Bibliothek", pillar_library_body: "Gespeicherte Whitepaper, In-App-PDFs.",
    pillar_referrals: "Empfehlungen", pillar_referrals_body: "Einladen & Premium freischalten.",
    pillar_certs: "Zertifikate", pillar_certs_body: "Verdienen, auf LinkedIn teilen.",
    modes_title: "Lernmodi",
    mode_universal: "Universalsprache",
    mode_universal_body: "Muttersprachliche Generierung in 25 Sprachen.",
    mode_sim: "Simulationsmodus",
    mode_sim_body: "Interaktives Rollenspiel: Entscheidung, Optionen, Debrief.",
    mode_cross: "Kreuzbestäubung",
    mode_cross_body: "Wähle jede Linse — Sport, Kunst, Biologie.",
    open: "Öffnen",
    discover_eyebrow: "Finde deinen Kurs",
    discover_title: "Unsicher, was du heute lernen willst? Wir helfen dir.",
    discover_sub: "Wähle eine Kategorie und einen Fokus — wir zeigen dir die beliebtesten Kurse. Ein Klick generiert den kompletten Pfad.",
    discover_pick_category: "1. Kategorie wählen",
    discover_pick_category_placeholder: "Kategorie auswählen…",
    discover_pick_subcategory: "2. Fokusbereich wählen",
    discover_pick_subcategory_placeholder: "Fokusbereich auswählen…",
    discover_pick_subcategory_disabled: "Zuerst Kategorie wählen",
    discover_hot_trending: "Heiß · Plattformweit angesagt",
    discover_hot_in_category: "Heiß in {cat}",
    discover_hot_in_subcategory: "Heiß in {sub}",
    discover_chip_hint: "Zum Generieren des Kurses klicken",
    lang_persona_help: "Sprache & Ton steuern AUDIO und KURS-Inhalte (Whitepaper, Prüfungen, Sprecher). Auch die Oberfläche wird in unterstützten Sprachen übersetzt.",
    nav_earn_credits: "Credits verdienen",
    modes_tooltip: "Entdecke diese Funktionen, indem du auf den Bereich „AI Academy“ klickst.",
    cert_eyebrow: "Zertifikat freigeschaltet",
    cert_title: "Dein Oak AI Campus Zertifikat",
    cert_sub: "Eine filmreife, markeneigene Qualifikation. Halte sie als Bild fest und teile sie plattformübergreifend.",
    cert_label_name: "Dies bescheinigt, dass",
    cert_completed: "einen strukturierten Meisterschaftspfad abgeschlossen hat in",
    cert_equity: "Wissensgerechtigkeit",
    cert_modules: "Module",
    cert_exams: "Prüfungen",
    cert_saved: "Gespeicherte PDFs",
    cert_issued: "Ausgestellt",
    cert_founder: "Ausgestellt von Oak AI Campus",
    cert_back: "Zurück",
    cert_image_btn: "Filmreifes Bild",
    cert_image_rendering: "Wird gerendert…",
    cert_json: "JSON-Datensatz",
    discover_free_credits: "Kostenlos mit deinen Credits",
    discover_free_limitless: "Kostenlos · Limitless-Abo",
    discover_free_hint: "Jeder Kurs = 1 Credit (oder unbegrenzt mit Limitless)",
    footer_tagline: "Alles meistern. Powered by Oak AI Campus.",
    footer_blurb: "Ein filmreifer, KI-geführter Weg zur Meisterschaft. Gemacht für unermüdliche Lerner.",
    footer_legal: "Rechtliches",
    footer_privacy: "Datenschutzrichtlinie",
    footer_terms: "Nutzungsbedingungen",
    footer_refund: "Rückerstattungsrichtlinie",
    footer_settings: "Einstellungen & Datenschutz",
    footer_contact: "Kontakt",
    footer_concept: "Konzipiert von",
    footer_built_by: "und entwickelt von",
    footer_rights: "Alle Rechte vorbehalten",
    showcase_eyebrow: "Live-Vorschauen · eine pro Kategorie",
    showcase_paths_count: "{n} Pfade",
    showcase_added_this_week: "{n} diese Woche hinzugefügt",
    showcase_title: "Einblick in einen echten OAK Kurs",
    showcase_subtitle: "Kostenlose 10 % Vorschau auf jedem Pfad · schalte den Rest mit 6 kostenlosen Credits bei der Anmeldung frei.",
    showcase_explore_more: "Weitere Live-Vorschauen entdecken",
    showcase_empty: "Noch keine öffentlichen Vorschauen — schau bald wieder vorbei.",
    showcase_free_pct: "10 % kostenlos",
    showcase_read_preview: "Vorschau lesen",
    nav_my_courses: "Meine Kurse",
    my_courses_empty: "Noch keine Kurse — erstellen Sie einen über das Dashboard.",
    loading: "Wird geladen…",
      },
  zh: {
    nav_home: "首页", nav_academy: "学院", nav_planner: "规划", nav_library: "书库", nav_profile: "个人资料",
    header_brand_tagline: "掌握一切 · Oak AI Campus",
    header_watch_ad: "观看广告 · +1",
    header_get_credits: "获取积分",
    header_upgrade: "立即升级",
    header_credits: "积分",
    hub_eyebrow: "通用学习中心",
    hub_title_pre: "你今天想",
    hub_title_word: "掌握",
    hub_title_post: "什么?",
    hub_sub: "输入任何主题 — 用你的语言、你的声音。Oak AI Campus 为你搭建 30 分钟 5 步掌握路径。",
    hub_placeholder: "学习衍生品、量子力学、宏观经济学…",
    btn_generate: "生成",
    pillar_academy: "AI 学院", pillar_academy_body: "5 步路径,30 分钟白皮书,自适应考试。",
    pillar_planner: "规划", pillar_planner_body: "自动生成日程与提醒。",
    pillar_library: "我的书库", pillar_library_body: "保存的白皮书,应用内 PDF。",
    pillar_referrals: "邀请", pillar_referrals_body: "邀请好友,解锁高级声音。",
    pillar_certs: "证书", pillar_certs_body: "获得并分享到 LinkedIn。",
    modes_title: "学习模式",
    mode_universal: "通用语言",
    mode_universal_body: "支持 25 种语言的原生内容生成。",
    mode_sim: "模拟模式",
    mode_sim_body: "互动角色扮演:做决定、听点评。",
    mode_cross: "跨域类比",
    mode_cross_body: "选择任意视角 — 体育、艺术、生物。",
    open: "打开",
    nav_earn_credits: "赚取积分",
    modes_tooltip: "点击AI Academy部分，探索这些功能。",
    cert_eyebrow: "证书已解锁",
    cert_title: "您的Oak AI Campus证书",
    cert_sub: "一张电影感十足、品牌专属的证书。您可以将其截取为图片并在各平台分享。",
    cert_label_name: "特此证明",
    cert_completed: "已完成关于以下内容的结构化精通路径",
    cert_equity: "知识公平",
    cert_modules: "模块",
    cert_exams: "考试",
    cert_saved: "已保存的PDF",
    cert_issued: "颁发日期",
    cert_founder: "由 Oak AI Campus 颁发",
    cert_back: "返回",
    cert_image_btn: "电影感图片",
    cert_image_rendering: "正在渲染…",
    cert_json: "JSON记录",
    discover_eyebrow: "查找您的课程",
    discover_title: "不确定今天想学什么？我们来帮您。",
    discover_sub: "选择一个类别和一个重点领域 — 我们将为您呈现最热门且最具影响力的课程。一键生成完整路径。",
    discover_pick_category: "1. 选择一个类别",
    discover_pick_category_placeholder: "选择一个类别…",
    discover_pick_subcategory: "2. 选择一个重点领域",
    discover_pick_subcategory_placeholder: "选择一个重点领域…",
    discover_pick_subcategory_disabled: "请先选择一个类别",
    discover_hot_trending: "热门 · 平台趋势",
    discover_hot_in_category: "{cat}热门",
    discover_hot_in_subcategory: "{sub}热门",
    discover_chip_hint: "点击生成此课程",
    discover_free_credits: "使用您的积分免费",
    discover_free_limitless: "免费 · 无限计划",
    discover_free_hint: "每门课程 = 1个积分（无限计划用户无限）",
    footer_tagline: "精通一切。由Oak AI Campus驱动。",
    footer_blurb: "一条电影般的、AI引导的精通之路。专为不懈学习者打造。",
    footer_legal: "法律",
    footer_privacy: "隐私政策",
    footer_terms: "服务条款",
    footer_refund: "退款政策",
    footer_settings: "设置与隐私",
    footer_contact: "联系我们",
    footer_concept: "概念设计",
    footer_built_by: "并由",
    footer_rights: "保留所有权利",
    showcase_eyebrow: "实时预览 · 每个类别一个",
    showcase_paths_count: "{n}条路径",
    showcase_added_this_week: "本周新增{n}个",
    showcase_title: "一窥OAK真实课程",
    showcase_subtitle: "每条路径免费10%预览 · 注册即可获得6个免费积分，解锁其余内容。",
    showcase_explore_more: "探索更多实时预览",
    showcase_empty: "暂无公开预览 — 请稍后回来查看。",
    showcase_free_pct: "免费10%",
    showcase_read_preview: "阅读预览",
    lang_persona_help: "语言和语气控制着音频和课程内容（白皮书、考试问题、旁白）。网站界面在支持的情况下也会翻译成您的语言。",
    nav_my_courses: "我的课程",
    my_courses_empty: "暂无课程 — 从仪表盘生成一个。",
    loading: "加载中…",
      },
  es: {
    nav_home: "Inicio", nav_academy: "Academia", nav_planner: "Agenda", nav_library: "Biblioteca", nav_profile: "Perfil",
    header_brand_tagline: "Domina cualquier cosa · Oak AI Campus",
    header_watch_ad: "Ver anuncio · +1",
    header_get_credits: "Obtener créditos",
    header_upgrade: "Actualizar ahora",
    header_credits: "crédito",
    hub_eyebrow: "Centro de aprendizaje universal",
    hub_title_pre: "¿Qué quieres",
    hub_title_word: "dominar",
    hub_title_post: "hoy?",
    hub_sub: "Escribe cualquier cosa — en tu idioma, en tu voz. Oak AI Campus crea un camino de dominio de 30 min en 5 pasos.",
    hub_placeholder: "Aprende derivadas, mecánica cuántica, macroeconomía…",
    btn_generate: "Generar",
    pillar_academy: "Academia IA", pillar_academy_body: "Caminos de 5 pasos, whitepapers de 30 min, exámenes adaptativos.",
    pillar_planner: "Agenda", pillar_planner_body: "Auto-programa recordatorios.",
    pillar_library: "Mi biblioteca", pillar_library_body: "Whitepapers guardados, PDFs en la app.",
    pillar_referrals: "Referidos", pillar_referrals_body: "Invita y desbloquea voces premium.",
    pillar_certs: "Certificados", pillar_certs_body: "Gana y comparte en LinkedIn.",
    modes_title: "Modos de aprendizaje",
    mode_universal: "Idioma universal",
    mode_universal_body: "Generación nativa en 25 idiomas.",
    mode_sim: "Modo simulación",
    mode_sim_body: "Roleplay interactivo con debriefing.",
    mode_cross: "Polinización cruzada",
    mode_cross_body: "Elige un lente: deportes, arte, biología.",
    open: "Abrir",
    nav_earn_credits: "Gana créditos",
    modes_tooltip: "Explora estas funciones haciendo clic en la sección de AI Academy.",
    cert_eyebrow: "Certificado desbloqueado",
    cert_title: "Tu certificado Oak AI Campus",
    cert_sub: "Una credencial cinemática, propiedad de la marca. Captúrala como imagen y compártela en todas las plataformas.",
    cert_label_name: "Certifica que",
    cert_completed: "ha completado una ruta de maestría estructurada en",
    cert_equity: "Equidad del conocimiento",
    cert_modules: "Módulos",
    cert_exams: "Exámenes",
    cert_saved: "PDFs guardados",
    cert_issued: "Emitido",
    cert_founder: "Emitido por Oak AI Campus",
    cert_back: "Volver",
    cert_image_btn: "Imagen cinemática",
    cert_image_rendering: "Renderizando…",
    cert_json: "Registro JSON",
    discover_eyebrow: "Encuentra tu curso",
    discover_title: "¿Confundido sobre qué quieres aprender hoy? Te ayudamos.",
    discover_sub: "Elige una categoría y un área de enfoque; te mostraremos los cursos más populares y de mayor impacto. Un clic genera la ruta completa.",
    discover_pick_category: "1. Elige una categoría",
    discover_pick_category_placeholder: "Elige una categoría…",
    discover_pick_subcategory: "2. Elige un área de enfoque",
    discover_pick_subcategory_placeholder: "Elige un área de enfoque…",
    discover_pick_subcategory_disabled: "Elige una categoría primero",
    discover_hot_trending: "Popular · Tendencias en la plataforma",
    discover_hot_in_category: "Popular en {cat}",
    discover_hot_in_subcategory: "Popular en {sub}",
    discover_chip_hint: "Haz clic para generar este curso",
    discover_free_credits: "Gratis con tus créditos",
    discover_free_limitless: "Gratis · Plan Limitless",
    discover_free_hint: "Cada curso = 1 crédito (o ilimitado con Limitless)",
    footer_tagline: "Domina cualquier cosa. Desarrollado por Oak AI Campus.",
    footer_blurb: "Una ruta cinemática, guiada por IA, hacia la maestría. Creada para aprendices incansables.",
    footer_legal: "Legal",
    footer_privacy: "Política de privacidad",
    footer_terms: "Términos de servicio",
    footer_refund: "Política de reembolso",
    footer_settings: "Configuración y privacidad",
    footer_contact: "Contacto",
    footer_concept: "Conceptualizado por",
    footer_built_by: "y desarrollado por",
    footer_rights: "Todos los derechos reservados",
    showcase_eyebrow: "Previsualizaciones en vivo · una por categoría",
    showcase_paths_count: "{n} rutas",
    showcase_added_this_week: "{n} añadidas esta semana",
    showcase_title: "Echa un vistazo a un curso OAK real",
    showcase_subtitle: "Previsualización gratuita del 10% en cada ruta · desbloquea el resto con 6 créditos gratuitos al registrarte.",
    showcase_explore_more: "Explora más previsualizaciones en vivo",
    showcase_empty: "Todavía no hay previsualizaciones públicas — vuelve pronto.",
    showcase_free_pct: "10% gratis",
    showcase_read_preview: "Leer previsualización",
    lang_persona_help: "El idioma y el tono controlan el contenido de AUDIO y del CURSO (documentos técnicos, preguntas de examen, narración). La interfaz del sitio web también se traduce a tu idioma donde sea compatible.",
    nav_my_courses: "Mis cursos",
    my_courses_empty: "Aún no tienes cursos — genera uno desde el panel de control.",
    loading: "Cargando…",
      },
  fr: {
    nav_home: "Accueil", nav_academy: "Académie", nav_planner: "Agenda", nav_library: "Bibliothèque", nav_profile: "Profil",
    header_brand_tagline: "Maîtrisez tout · Oak AI Campus",
    header_watch_ad: "Voir pub · +1",
    header_get_credits: "Obtenir crédits",
    header_upgrade: "Passer Pro",
    header_credits: "crédit",
    hub_eyebrow: "Hub d'apprentissage universel",
    hub_title_pre: "Que voulez-vous",
    hub_title_word: "maîtriser",
    hub_title_post: "aujourd'hui ?",
    hub_sub: "Tapez n'importe quoi — dans votre langue, votre voix. Oak AI Campus crée un parcours de 30 min en 5 étapes.",
    hub_placeholder: "Apprendre les dérivées, la mécanique quantique…",
    btn_generate: "Générer",
    pillar_academy: "Académie IA", pillar_academy_body: "Parcours de 5 étapes, whitepapers 30 min, examens adaptatifs.",
    pillar_planner: "Agenda", pillar_planner_body: "Rappels automatiques.",
    pillar_library: "Ma bibliothèque", pillar_library_body: "Whitepapers sauvegardés, PDFs dans l'app.",
    pillar_referrals: "Parrainages", pillar_referrals_body: "Invitez et débloquez les voix premium.",
    pillar_certs: "Certificats", pillar_certs_body: "Gagnez et partagez sur LinkedIn.",
    modes_title: "Modes d'apprentissage",
    mode_universal: "Langue universelle",
    mode_universal_body: "Génération native en 25 langues.",
    mode_sim: "Mode Simulation",
    mode_sim_body: "Jeux de rôle interactifs avec débriefing.",
    mode_cross: "Pollinisation croisée",
    mode_cross_body: "Choisissez un prisme : sport, art, biologie.",
    open: "Ouvrir",
    nav_earn_credits: "Gagner des crédits",
    modes_tooltip: "Explorez ces fonctionnalités en cliquant sur la section AI Academy.",
    cert_eyebrow: "Certificat débloqué",
    cert_title: "Votre certificat Oak AI Campus",
    cert_sub: "Un titre de compétence cinématique, propriété de la marque. Capturez-le comme une image et partagez-le sur toutes les plateformes.",
    cert_label_name: "Ceci certifie que",
    cert_completed: "a complété un parcours de maîtrise structuré sur",
    cert_equity: "Équité des connaissances",
    cert_modules: "Modules",
    cert_exams: "Examens",
    cert_saved: "PDF enregistrés",
    cert_issued: "Émis le",
    cert_founder: "Délivré par Oak AI Campus",
    cert_back: "Retour",
    cert_image_btn: "Image cinématique",
    cert_image_rendering: "Rendu en cours…",
    cert_json: "Enregistrement JSON",
    discover_eyebrow: "Trouvez votre cours",
    discover_title: "Vous ne savez pas quoi apprendre aujourd'hui ? Laissez-nous vous aider.",
    discover_sub: "Choisissez une catégorie et un domaine d'intérêt — nous vous proposerons les cours les plus populaires et les plus impactants. Un clic génère le parcours complet.",
    discover_pick_category: "1. Choisissez une catégorie",
    discover_pick_category_placeholder: "Choisissez une catégorie…",
    discover_pick_subcategory: "2. Choisissez un domaine d'intérêt",
    discover_pick_subcategory_placeholder: "Choisissez un domaine d'intérêt…",
    discover_pick_subcategory_disabled: "Choisissez d'abord une catégorie",
    discover_hot_trending: "Populaire · Tendance sur toute la plateforme",
    discover_hot_in_category: "Populaire dans {cat}",
    discover_hot_in_subcategory: "Populaire dans {sub}",
    discover_chip_hint: "Cliquez pour générer ce cours",
    discover_free_credits: "Gratuit avec vos crédits",
    discover_free_limitless: "Gratuit · Plan Illimité",
    discover_free_hint: "Chaque cours = 1 crédit (ou illimité avec le plan Illimité)",
    footer_tagline: "Maîtrisez n'importe quoi. Propulsé par Oak AI Campus.",
    footer_blurb: "Un parcours de maîtrise cinématique guidé par l'IA. Conçu pour les apprenants acharnés.",
    footer_legal: "Mentions légales",
    footer_privacy: "Politique de confidentialité",
    footer_terms: "Conditions d'utilisation",
    footer_refund: "Politique de remboursement",
    footer_settings: "Paramètres et confidentialité",
    footer_contact: "Contact",
    footer_concept: "Conceptualisé par",
    footer_built_by: "et réalisé par",
    footer_rights: "Tous droits réservés",
    showcase_eyebrow: "Aperçus en direct · un par catégorie",
    showcase_paths_count: "{n} parcours",
    showcase_added_this_week: "{n} ajoutés cette semaine",
    showcase_title: "Découvrez un vrai cours OAK",
    showcase_subtitle: "Aperçu gratuit de 10 % sur chaque parcours · débloquez le reste avec 6 crédits gratuits à l'inscription.",
    showcase_explore_more: "Explorer plus d'aperçus en direct",
    showcase_empty: "Aucun aperçu public pour le moment — revenez bientôt.",
    showcase_free_pct: "10 % gratuit",
    showcase_read_preview: "Lire l'aperçu",
    lang_persona_help: "La langue et le ton contrôlent le contenu AUDIO et de COURS (livres blancs, questions d'examen, narration). L'interface du site web est également traduite dans votre langue, le cas échéant.",
    nav_my_courses: "Mes cours",
    my_courses_empty: "Aucun cours pour l'instant — générez-en un depuis le tableau de bord.",
    loading: "Chargement…",
      },
  ja: {
    nav_home: "ホーム", nav_academy: "アカデミー", nav_planner: "プランナー", nav_library: "ライブラリ", nav_profile: "プロフィール",
    header_brand_tagline: "何でも極める · Oak AI Campus",
    header_watch_ad: "広告を見る · +1",
    header_get_credits: "クレジット取得",
    header_upgrade: "今すぐアップグレード",
    header_credits: "クレジット",
    hub_eyebrow: "ユニバーサル学習ハブ",
    hub_title_pre: "今日は何を",
    hub_title_word: "極めますか",
    hub_title_post: "?",
    hub_sub: "あなたの言語・声で何でもタイプ。Oak AI Campus が30分5ステップの習得パスを生成します。",
    hub_placeholder: "微分、量子力学、マクロ経済学を学ぶ…",
    btn_generate: "生成",
    pillar_academy: "AI アカデミー", pillar_academy_body: "5ステップ・30分白書・適応試験。",
    pillar_planner: "プランナー", pillar_planner_body: "自動スケジュール & リマインダー。",
    pillar_library: "マイライブラリ", pillar_library_body: "保存済み白書、アプリ内 PDF。",
    pillar_referrals: "紹介", pillar_referrals_body: "招待してプレミアム音声を解放。",
    pillar_certs: "証明書", pillar_certs_body: "獲得して LinkedIn でシェア。",
    modes_title: "学習モード",
    mode_universal: "万能言語",
    mode_universal_body: "25言語のネイティブ生成。",
    mode_sim: "シミュレーションモード",
    mode_sim_body: "対話型ロールプレイ・解説付き。",
    mode_cross: "クロスポリネーション",
    mode_cross_body: "スポーツ・芸術・生物のレンズを選択。",
    open: "開く",
    nav_earn_credits: "クレジットを獲得",
    modes_tooltip: "AI Academyセクションをクリックして、これらの機能を探索してください。",
    cert_eyebrow: "証明書をアンロックしました",
    cert_title: "あなたのOak AI Campus証明書",
    cert_sub: "映画のような、ブランド独自の資格情報。画像としてキャプチャし、プラットフォーム間で共有しましょう。",
    cert_label_name: "これにより、以下の者が認定されます：",
    cert_completed: "は、以下の分野で体系的な習得パスを修了しました：",
    cert_equity: "知識の公平性",
    cert_modules: "モジュール",
    cert_exams: "試験",
    cert_saved: "保存済みPDF",
    cert_issued: "発行日",
    cert_founder: "Oak AI Campus 発行",
    cert_back: "戻る",
    cert_image_btn: "シネマティック画像",
    cert_image_rendering: "レンダリング中…",
    cert_json: "JSONレコード",
    discover_eyebrow: "コースを見つける",
    discover_title: "今日何を学びたいか迷っていますか？お手伝いさせてください。",
    discover_sub: "カテゴリと重点分野を選んでください — 最も人気があり、影響力の大きいコースを表示します。ワンクリックで全パスが生成されます。",
    discover_pick_category: "1. カテゴリを選ぶ",
    discover_pick_category_placeholder: "カテゴリを選択…",
    discover_pick_subcategory: "2. 重点分野を選ぶ",
    discover_pick_subcategory_placeholder: "重点分野を選択…",
    discover_pick_subcategory_disabled: "まずカテゴリを選択してください",
    discover_hot_trending: "話題 · プラットフォーム全体でトレンド",
    discover_hot_in_category: "{cat}で話題",
    discover_hot_in_subcategory: "{sub}で話題",
    discover_chip_hint: "クリックしてこのコースを生成",
    discover_free_credits: "クレジットで無料",
    discover_free_limitless: "無料 · リミットレスプラン",
    discover_free_hint: "各コース = 1クレジット（またはリミットレスプランで無制限）",
    footer_tagline: "すべてを習得。Oak AI Campusが提供。",
    footer_blurb: "映画のような、AIガイドによる習得パス。たゆまぬ学習者のために構築。",
    footer_legal: "法務",
    footer_privacy: "プライバシーポリシー",
    footer_terms: "利用規約",
    footer_refund: "返金ポリシー",
    footer_settings: "設定とプライバシー",
    footer_contact: "お問い合わせ",
    footer_concept: "概念化",
    footer_built_by: "および構築",
    footer_rights: "全著作権所有",
    showcase_eyebrow: "ライブプレビュー · カテゴリごとに1つ",
    showcase_paths_count: "{n}個のパス",
    showcase_added_this_week: "今週{n}個追加",
    showcase_title: "実際のOAKコースを覗いてみる",
    showcase_subtitle: "すべてのパスで10%無料プレビュー · サインアップで6クレジットを獲得し、残りをアンロック。",
    showcase_explore_more: "その他のライブプレビューを見る",
    showcase_empty: "まだ公開プレビューはありません — 近日中にご確認ください。",
    showcase_free_pct: "10%無料",
    showcase_read_preview: "プレビューを読む",
    lang_persona_help: "言語とトーンは、音声とコースコンテンツ（ホワイトペーパー、試験問題、ナレーション）を制御します。ウェブサイトのUIも、サポートされている場合はあなたの言語に翻訳されます。",
    nav_my_courses: "マイコース",
    my_courses_empty: "まだコースがありません — ダッシュボードから作成してください。",
    loading: "読み込み中…",
      },
  ar: {
    nav_home: "الرئيسية", nav_academy: "الأكاديمية", nav_planner: "المخطط", nav_library: "المكتبة", nav_profile: "الملف الشخصي",
    header_brand_tagline: "أتقن أي شيء · Oak AI Campus",
    header_watch_ad: "شاهد إعلان · +1",
    header_get_credits: "الحصول على أرصدة",
    header_upgrade: "الترقية الآن",
    header_credits: "رصيد",
    hub_eyebrow: "مركز التعلم العالمي",
    hub_title_pre: "ماذا تريد أن",
    hub_title_word: "تتقن",
    hub_title_post: "اليوم؟",
    hub_sub: "اكتب أي شيء — بلغتك وصوتك. يبني Oak AI Campus مسار إتقان من 30 دقيقة في 5 خطوات.",
    hub_placeholder: "تعلم المشتقات، ميكانيكا الكم، الاقتصاد الكلي…",
    btn_generate: "إنشاء",
    pillar_academy: "أكاديمية الذكاء", pillar_academy_body: "مسارات من 5 خطوات، ورقات بيضاء 30 دقيقة.",
    pillar_planner: "المخطط", pillar_planner_body: "جداول وتذكيرات تلقائية.",
    pillar_library: "مكتبتي", pillar_library_body: "ورقات محفوظة، PDF داخل التطبيق.",
    pillar_referrals: "الإحالات", pillar_referrals_body: "ادعُ وافتح أصوات بريميوم.",
    pillar_certs: "الشهادات", pillar_certs_body: "اكسب وشارك على لينكدإن.",
    modes_title: "أوضاع التعلم",
    mode_universal: "لغة عالمية",
    mode_universal_body: "توليد أصلي في 25 لغة.",
    mode_sim: "وضع المحاكاة",
    mode_sim_body: "لعب أدوار تفاعلي مع استخلاص.",
    mode_cross: "التلاقح المعرفي",
    mode_cross_body: "اختر عدسة: رياضة، فن، أحياء.",
    open: "افتح",
    nav_earn_credits: "اكسب أرصدة",
    modes_tooltip: "استكشف هذه الميزات بالنقر على قسم Oak AI Campus.",
    cert_eyebrow: "شهادة مفتوحة",
    cert_title: "شهادة Oak AI Campus الخاصة بك",
    cert_sub: "وثيقة اعتماد سينمائية مملوكة للعلامة التجارية. التقطها كصورة وشاركها عبر المنصات.",
    cert_label_name: "تشهد هذه الوثيقة بأن",
    cert_completed: "قد أكمل مسار إتقان منظم في",
    cert_equity: "المساواة المعرفية",
    cert_modules: "الوحدات",
    cert_exams: "الاختبارات",
    cert_saved: "ملفات PDF المحفوظة",
    cert_issued: "تاريخ الإصدار",
    cert_founder: "صادر عن Oak AI Campus",
    cert_back: "رجوع",
    cert_image_btn: "صورة سينمائية",
    cert_image_rendering: "جاري المعالجة…",
    cert_json: "سجل JSON",
    discover_eyebrow: "ابحث عن دورتك",
    discover_title: "هل أنت حائر بشأن ما تريد تعلمه اليوم؟ دعنا نساعدك.",
    discover_sub: "اختر فئة ومجال تركيز — وسنعرض لك الدورات الأكثر شيوعًا وتأثيرًا. نقرة واحدة تنشئ المسار الكامل.",
    discover_pick_category: "1. اختر فئة",
    discover_pick_category_placeholder: "اختر فئة…",
    discover_pick_subcategory: "2. اختر مجال تركيز",
    discover_pick_subcategory_placeholder: "اختر مجال تركيز…",
    discover_pick_subcategory_disabled: "اختر فئة أولاً",
    discover_hot_trending: "شائع · رائج عبر المنصة",
    discover_hot_in_category: "شائع في {cat}",
    discover_hot_in_subcategory: "شائع في {sub}",
    discover_chip_hint: "انقر لإنشاء هذه الدورة",
    discover_free_credits: "مجاني باستخدام أرصدتك",
    discover_free_limitless: "مجاني · خطة لا حدود لها",
    discover_free_hint: "كل دورة = رصيد واحد (أو غير محدود مع خطة Limitless)",
    footer_tagline: "أتقن أي شيء. مدعوم من Oak AI Campus.",
    footer_blurb: "مسار سينمائي موجه بالذكاء الاصطناعي نحو الإتقان. مصمم للمتعلمين الدؤوبين.",
    footer_legal: "قانوني",
    footer_privacy: "سياسة الخصوصية",
    footer_terms: "شروط الخدمة",
    footer_refund: "سياسة الاسترداد",
    footer_settings: "الإعدادات والخصوصية",
    footer_contact: "اتصل بنا",
    footer_concept: "تصور من قبل",
    footer_built_by: "وبُني بواسطة",
    footer_rights: "جميع الحقوق محفوظة",
    showcase_eyebrow: "معاينات مباشرة · واحدة لكل فئة",
    showcase_paths_count: "{n} مسارات",
    showcase_added_this_week: "تم إضافة {n} هذا الأسبوع",
    showcase_title: "ألقِ نظرة خاطفة على دورة OAK حقيقية",
    showcase_subtitle: "معاينة مجانية 10% على كل مسار · افتح الباقي بـ 6 أرصدة مجانية عند التسجيل.",
    showcase_explore_more: "استكشف المزيد من المعاينات المباشرة",
    showcase_empty: "لا توجد معاينات عامة بعد — يرجى التحقق مرة أخرى قريباً.",
    showcase_free_pct: "10% مجانًا",
    showcase_read_preview: "قراءة المعاينة",
    lang_persona_help: "اللغة والنبرة تتحكمان في محتوى الصوت والدورة (الوثائق التقنية، أسئلة الاختبارات، السرد). تتم ترجمة واجهة الموقع أيضاً إلى لغتك حيثما يكون ذلك مدعوماً.",
    nav_my_courses: "دوراتي",
    my_courses_empty: "لا توجد دورات بعد — قم بإنشاء واحدة من لوحة التحكم.",
    loading: "جار التحميل...",
      },
};

// First-contact welcome toast in the learner's detected language.
// Covers all 25 supported languages; falls back to English.
export const WELCOME_MESSAGES = {
  en: "Welcome — Oak AI Campus is ready in your language.",
  hi: "आपका स्वागत है — Oak AI Campus आपकी भाषा में तैयार है।",
  de: "Willkommen — Oak AI Campus ist bereit in Ihrer Sprache.",
  zh: "欢迎 — Oak AI Campus 已为您的语言准备就绪。",
  es: "Bienvenido — Oak AI Campus está listo en tu idioma.",
  fr: "Bienvenue — Oak AI Campus est prêt dans votre langue.",
  ja: "ようこそ — Oak AI Campus はあなたの言語で準備できています。",
  ko: "환영합니다 — Oak AI Campus가 당신의 언어로 준비되었습니다.",
  pt: "Bem-vindo — Oak AI Campus está pronto no seu idioma.",
  ru: "Добро пожаловать — Oak AI Campus готов на вашем языке.",
  it: "Benvenuto — Oak AI Campus è pronto nella tua lingua.",
  ar: "مرحبًا — Oak AI Campus جاهز بلغتك.",
  tr: "Hoş geldiniz — Oak AI Campus dilinizde hazır.",
  id: "Selamat datang — Oak AI Campus siap dalam bahasa Anda.",
  nl: "Welkom — Oak AI Campus is klaar in uw taal.",
  vi: "Chào mừng — Oak AI Campus đã sẵn sàng bằng ngôn ngữ của bạn.",
  ta: "வரவேற்கிறோம் — Oak AI Campus உங்கள் மொழியில் தயாராக உள்ளது.",
  te: "స్వాగతం — Oak AI Campus మీ భాషలో సిద్ధంగా ఉంది.",
  bn: "স্বাগতম — Oak AI Campus আপনার ভাষায় প্রস্তুত।",
  mr: "स्वागत आहे — Oak AI Campus तुमच्या भाषेत तयार आहे.",
  gu: "સ્વાગત છે — Oak AI Campus તમારી ભાષામાં તૈયાર છે.",
  pa: "ਜੀ ਆਇਆਂ ਨੂੰ — Oak AI Campus ਤੁਹਾਡੀ ਭਾਸ਼ਾ ਵਿੱਚ ਤਿਆਰ ਹੈ।",
  ml: "സ്വാഗതം — Oak AI Campus നിങ്ങളുടെ ഭാഷയിൽ തയ്യാറാണ്.",
  kn: "ಸ್ವಾಗತ — Oak AI Campus ನಿಮ್ಮ ಭಾಷೆಯಲ್ಲಿ ಸಿದ್ಧವಾಗಿದೆ.",
  ur: "خوش آمدید — Oak AI Campus آپ کی زبان میں تیار ہے۔",
};

// Subtle trust/attribution line shown under AI-generated content headings.
// Italic, low-opacity rendering is handled at the component level.
export const TRUST_LINES = {
  en: "Natively generated via Oak AI Campus",
  hi: "Oak AI Campus द्वारा मूल रूप से तैयार",
  de: "Nativ erstellt mit Oak AI Campus",
  zh: "由 Oak AI Campus 原生生成",
  es: "Generado nativamente por Oak AI Campus",
  fr: "Généré nativement par Oak AI Campus",
  ja: "Oak AI Campus によってネイティブに生成",
  ko: "Oak AI Campus로 네이티브 생성됨",
  pt: "Gerado nativamente pela Oak AI Campus",
  ru: "Изначально создано в Oak AI Campus",
  it: "Generato nativamente da Oak AI Campus",
  ar: "تم إنشاؤه أصليًا بواسطة Oak AI Campus",
  tr: "Oak AI Campus ile yerel olarak oluşturuldu",
  id: "Dihasilkan secara native oleh Oak AI Campus",
  nl: "Native gegenereerd met Oak AI Campus",
  vi: "Được tạo ra nguyên bản bởi Oak AI Campus",
  ta: "Oak AI Campus ஆல் சொந்தமாக உருவாக்கப்பட்டது",
  te: "Oak AI Campus ద్వారా స్థానికంగా రూపొందించబడింది",
  bn: "Oak AI Campus দ্বারা নেটিভভাবে তৈরি",
  mr: "Oak AI Campus द्वारे मूळ स्वरूपात तयार",
  gu: "Oak AI Campus દ્વારા મૂળરૂપે તૈયાર",
  pa: "Oak AI Campus ਵੱਲੋਂ ਮੂਲ ਰੂਪ ਵਿੱਚ ਤਿਆਰ",
  ml: "Oak AI Campus സ്വാഭാവികമായി സൃഷ്ടിച്ചത്",
  kn: "Oak AI Campus ನಿಂದ ಸ್ಥಳೀಯವಾಗಿ ರಚಿಸಲಾಗಿದೆ",
  ur: "Oak AI Campus کی جانب سے مقامی طور پر تیار",
};

export function trustLine(lang) {
  return TRUST_LINES[lang] || TRUST_LINES.en;
}

// Falls back to English for any missing key or unsupported language.
export function tFactory(lang) {
  const dict = TRANSLATIONS[lang] || {};
  const fallback = TRANSLATIONS.en;
  return (key) => dict[key] ?? fallback[key] ?? key;
}
